import { getBranchList } from '@/api/branch'
import { getSupplierList } from '@/api/supplier'

// 门店列表
export const mixinGetBranchList = {
  data() {
    return {
      branches: []
    }
  },
  created() {
    this.getBranchList()
  },
  methods: {
    getBranchList: function () {
      getBranchList().then(res => {
        this.branches = res.list
      })
    },
  }
}

// 供应商列表
export const mixinGetSupplierList = {
  data() {
    return {
      suppliers: []
    }
  },
  created() {
    this.getSupplierList()
  },
  methods: {
    getSupplierList: function () {
      getSupplierList().then(res => {
        this.suppliers = res.list
      })
    },
  }
}